import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import GroupHeader from '../GroupHeader';
import CategoriesGroupForm from './Form/Form';
import { getCurrencySymbol } from 'src/shared/utils/currency';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useGetUserHoldingQuery } from 'src/shared/api/holding';
import { type FlexflowLimits } from '../../Contracts/types';

const CategoriesGroup = ({ flexflowCategoriesLimit }: { flexflowCategoriesLimit: FlexflowLimits }) => {
  const classes = useStyles();
  const { data } = useGetUserHoldingQuery();
  const currencySymbol = getCurrencySymbol(data?.territory?.isoCode, data?.territory?.currency);
  const { t } = useTranslation(['flexflow']);
  const totalMonthlyLimit = flexflowCategoriesLimit?.globalLimit ?? 0;

  return (
    <Grid2 container>
      <GroupHeader
        className={classes.tooltipWrapper}
        marginTop={32}
        tooltipTitle={
          t('configuration.tooltip', {
            ns: 'flexflow'
          }) ?? ''
        }
      >
        {t('configuration.title', { ns: 'flexflow' })}
      </GroupHeader>

      <Grid2 mb={4} xs={12} md={10} lg={6}>
        <div>
          <CategoriesGroupForm monthlyTotalLimit={totalMonthlyLimit} currencySymbol={currencySymbol} />
        </div>
      </Grid2>
    </Grid2>
  );
};

export default CategoriesGroup;
